import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ICrudGetProps } from '@monorepo/tools/src/lib/interfaces/crud';
import { IAdminxStore } from '../../stores';

export function useTestGet(props: ICrudGetProps) {
	const { id, options } = props;
	const { testStore } = useStores<IAdminxStore>();
	const location = useLocation();

	useEffect(() => {
		if (id) {
			testStore.getCrud().get(id, options);
		}
		// TODO - think maybe when unmount reset to crud model
	}, [location]);

	if (!id) {
		return null;
	}

	return { error: testStore.getCrud().getHttpError(), isLoading: testStore.getCrud().getIsLoading() };
}
